const countries = [
  { label: "Afghanistan", value: "AF", region: "Asia" },
  { label: "Albania", value: "AL", region: "Europe" },
  { label: "Algeria", value: "DZ", region: "Africa" },
  { label: "Argentina", value: "AR", region: "South America" },
  { label: "Australia", value: "AU", region: "Oceania" },
  { label: "Austria", value: "AT", region: "Europe" },
  { label: "Bangladesh", value: "BD", region: "Asia" },
  { label: "Belgium", value: "BE", region: "Europe" },
  { label: "Brazil", value: "BR", region: "South America" },
  { label: "Canada", value: "CA", region: "North America" },
  { label: "China", value: "CN", region: "Asia" },
  { label: "Denmark", value: "DK", region: "Europe" },
  { label: "Egypt", value: "EG", region: "Africa" },
  { label: "Finland", value: "FI", region: "Europe" },
  { label: "France", value: "FR", region: "Europe" },
  { label: "Germany", value: "DE", region: "Europe" },
  { label: "India", value: "IN", region: "Asia" },
  { label: "Indonesia", value: "ID", region: "Asia" },
  { label: "Ireland", value: "IE", region: "Europe" },
  { label: "Italy", value: "IT", region: "Europe" },
  { label: "Japan", value: "JP", region: "Asia" },
  { label: "Malaysia", value: "MY", region: "Asia" },
  { label: "Mexico", value: "MX", region: "North America" },
  { label: "Netherlands", value: "NL", region: "Europe" },
  { label: "New Zealand", value: "NZ", region: "Oceania" },
  { label: "Norway", value: "NO", region: "Europe" },
  { label: "Pakistan", value: "PK", region: "Asia" },
  { label: "Philippines", value: "PH", region: "Asia" },
  { label: "Russia", value: "RU", region: "Europe" }, 
  { label: "Saudi Arabia", value: "SA", region: "Middle East" },
  { label: "Singapore", value: "SG", region: "Asia" },
  { label: "South Africa", value: "ZA", region: "Africa" },
  { label: "South Korea", value: "KR", region: "Asia" },
  { label: "Spain", value: "ES", region: "Europe" },
  { label: "Sri Lanka", value: "LK", region: "Asia" },
  { label: "Sweden", value: "SE", region: "Europe" },
  { label: "Switzerland", value: "CH", region: "Europe" },
  { label: "Thailand", value: "TH", region: "Asia" },
  { label: "Turkey", value: "TR", region: "Middle East" },
  { label: "UAE", value: "AE", region: "Middle East" },
  { label: "UK", value: "GB", region: "Europe" },
  { label: "USA", value: "US", region: "North America" },
  { label: "Vietnam", value: "VN", region: "Asia" },
];

export default countries;